import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchBrand } from "services/api/brands";
import { AuthState } from "slices/auth/reducer";
import { ERROR } from "types";
import { Brand } from "types/brand";
import { getErrorMessage } from "utils/helpers";

export const fetchBrandData = createAsyncThunk<Brand, number, {rejectValue: string}>(
    'brand/fetch',
    async (id: number, {getState, rejectWithValue}) => {
        const state = getState() as {auth: AuthState};
        try {
            const brand = await fetchBrand(state.auth.selectedAgencyId!, id);
            return brand;
        } catch (error) {
            return rejectWithValue(getErrorMessage(error, ERROR.NOT_FOUND));
        }
    }
)